// extracted by mini-css-extract-plugin
module.exports = {"ldsRipple":"Loader_ldsRipple__3bUUx","lds-ripple":"Loader_lds-ripple__295Eb"};